export default [
    "BE",
    "BG",
    "CY",
    "DK",
    "DE",
    "EE",
    "FI",
    "FR",
    "GR",
    "HU",
    "IE",
    "IT",
    "HR",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "AW", // Aruba
    "CW", // Curaçao
    "SX", // Sint Maarten
    "BQ", // Caribbean Netherlands (Bonaire, Sint Eustatius, Saba)
    "AT",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "CZ",
    "UK",
    "GB",
    "VL",
    "SE",
];
